import moment from 'moment-timezone/builds/moment-timezone-with-data.min.js';

const getCurrentHour = (coast) => {
  const isEast = coast.toLowerCase() === 'east';
  const zone = isEast ? 'America/New_York' : 'America/Los_Angeles';
  const currentDate = new Date();
  const zonedHour = moment.tz(currentDate, zone).format('HH');

  return parseInt(zonedHour, 10);
};

const isSameDayAvailable = (coast, cutoffHour) => {
  const currentHour = getCurrentHour(coast);
  return currentHour < cutoffHour;
};

export {
  getCurrentHour,
  isSameDayAvailable,
};
